var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"quiz"}},[(_vm.iframeUrl)?_c('iframe',{staticClass:"typeform-widget",attrs:{"data-hj-allow-iframe":"","src":_vm.iframeUrl}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }